import base64 from 'base-64'
import utf8 from 'utf8'
const dealMethod = {
  data() {
    return {
      hasQueryFilter: false,       // url的query中有搜索条件
      hasFilterData: false,        // 当前搜索栏有输入搜索条件
      filterQuery: '',  // 搜索参数
      otherFilter: {}, // 来自自定义组件的筛选参数
      selfData: {},     // 自定义组件用的参数
      disableSizeChange: false,    // 禁止页面数据数量变化回调触发的标识
      disablePageChange: false,    // 禁止分页回调触发的标识
      commonFilterData: [], // 普通筛选数据
      advanceFilterData: [], // 高级筛选数据
      combinationNumber: null, // 组合筛选选择id
      isFirstPaymentConfig: false, // 默认不加载支付对话框，获取数据后加载
      sendParamsId: '', // 设置自动传参的id
      combinationData: {
        use_auth: '',
        build_auth: '',
        filter_fields: [],
        is_open: 1,
        select_map: []
      }, // 配置组合筛选条件
      editSource: {   // 编辑操作相关数据
        contentId: '',
        dealId: '',
        dataId: '',
        list: null,
        ids: null
      },
      statusSource: { // 一键修改字段值操作相关数据
        list: '',
        url: ''
      },
      deleteSource: {  // 删除操作相关数据
        url: '',
        id: '',
        isMul: false,
        ids: []
      },
      exportSource: {
        exportCols: [],
        url: '',
        postData: {},
        column: []
      },
      importSource: { // 导入操作相关数据
        url: ''
      },
      emailSource: {  // 发送邮件操作相关数据
        url: '',
        ids: [],
        dealId: ''
      },
      relateSource: { // 关联数据表相关数据
        ids: '', // 选中的id列表
        field_name: '', // 字段名
        title: '',
        url: '', // 请求列表数据对应的接口
        list_id: '' // 列表id
      }
    }
  },
  methods: {
    dealBtnEvent(deal, row, list) {  // 执行各种操作对应的方法
      switch (deal.type) {
        case this.OPERATION_LIST:
          this.goPage(deal.url)
          break
        case this.OPERATION_IFRAME:
          this.openIframe(deal, row, list)
          break
        case this.OPERATION_ADD:
          if (deal.show_type == this.OPERATION_ADD) {
            this.addItem(deal, null, list)
          } else if (deal.show_type == this.OPERATION_EDIT ||
              deal.show_type == this.OPERATION_DETAIL) {
            this.editItem(deal, row, list)
          }
          break
          // case this.OPERATION_EDIT:
          //   this.editItem(deal, row, list)
          //   break
          // case this.OPERATION_DETAIL:
          //   this.editItem(deal, row, list)
          //   break
        case this.OPERATION_DELETE:
          if (list) {
            this.deleteItem(deal, row, list)
          }
          break
        case this.OPERATION_IMPORT:
          let importId = 0
          _(this.listConfig.handle).forEach((handle) => {
            if (handle.type == this.OPERATION_IMPORT) {
              importId = handle.id
              return false
            }
          })
          this.importItem(list, importId)
          break
        case this.OPERATION_EXPORT:
          this.exportItem(deal, list)
          break
        case this.OPERATION_SEARCH:
          this.searchItem(list)
          break
        case this.OPERATION_FILTER:
          this.filterItem(deal, list)
          break
        case this.OPERATION_STATUS:
          this.changeStatus(deal, row, list)
          break
        case this.OPERATION_DOWNLOAD:
          if (row) {
            this.downloadRowItem(deal, row, list)
          } else {
            this.downloadMultiItem(deal, list)
          }
          break
        case this.OPERATION_MESSAGE:
          this.sendMessage(deal, row)
          break
        case this.OPERATION_EXEC:
          this.execFunction(deal, row, list)
          break
        case this.OPERATION_EXPORTWORD:
          this.exportWord(deal, row, list)
          break
        case this.OPERATION_MULTI_ADD:
          this.addItem(deal, row, list, true)
          break
        case this.OPERATION_MULTI_EDIT:
          this.editItem(deal, row, list, true)
          break
        case this.OPERATION_EMAIL:
          this.sendEmail(deal, row, list)
          break
        case this.OPERATION_DIMENSIONAL_CHART:
          this.dimensionalChart(deal, list)
          break
        default:
          this.goPage(deal.url)
          break
      }
    },
    goPage(url) {  // 执行添加操作
      router.push({ path: url })
    },
    addItem(deal, row, list, isMul) {
      if (isMul && _g.isRealEmpty(row) && _g.isRealEmpty(list.multipleSelection)) {
        _g.toastMsg(this, 'warning', '请先选择要处理的数据')
        return
      }
      if (deal.open_type == this.FORM_SHOW_PAGE) {  // 显示页面
        let query = {}
        if (isMul) {  // 如果是批量添加，带上id数组
          if (!row) { // 不是单行
            query.ids = list.multipleSelection
          } else {
            query.ids = [row.id]
          }
        }
        if (deal.is_query == 1 && this.$route.query.query) {
          query.query = this.$route.query.query
        }
        router.push({ path: deal.url, query: query })
      } else if (deal.open_type == this.FORM_SHOW_DIALOG) { //  显示弹窗
        this.editSource = {
          contentId: this.contentId,
          dealId: deal.id,
          dataId: 0,
          list: list,
          ids: null
        }
        if (isMul) {  // 如果是批量添加，带上id数组
          if (!row) { // 不是单行
            this.editSource.ids = list.multipleSelection
          } else {
            this.editSource.ids = [row.id]
          }
        }
        setTimeout(() => {
          this.$refs.editDeal.openDialog()
        }, 0)
      }
    },
    openIframe(deal, row, list) { // 执行打开iframe操作
      if (row) {
        let targetUrl = `${deal.url}?dataId=${row.id}`
        router.push({ path: targetUrl })
      }
    },
    editItem(deal, row, list, isMul) { // 执行编辑操作
      if (isMul && _g.isRealEmpty(list.multipleSelection)) {
        _g.toastMsg(this, 'warning', '请先选择要处理的数据')
        return
      }
      if (deal.open_type == this.FORM_SHOW_PAGE) {  // 显示页面
        let targetUrl = ''
        let query = {}
        if (isMul) {  // 如果是批量编辑，带上id数组
          targetUrl = deal.url
          query.ids = list.multipleSelection
        } else {
          targetUrl = `${deal.url}?dataId=${row.id}`
        }
        router.push({ path: targetUrl, query: query })
      } else if (deal.open_type == this.FORM_SHOW_DIALOG) { //  显示弹窗
        this.editSource = {
          contentId: this.contentId,
          dealId: deal.id,
          dataId: !isMul ? row.id : 0,
          list: list,
          ids: null
        }
        if (isMul) {  // 如果是批量编辑，带上id数组
          this.editSource.ids = list.multipleSelection
        }
        setTimeout(() => {
          this.$refs.editDeal.openDialog()
        }, 0)
      }
    },
    deleteItem(deal, row, list) {  // 执行删除操作
      if (row) {  // 单个删除
        this.deleteSource.id = row.id
        this.deleteSource.isMul = false
      } else {  // 批量删除
        this.deleteSource.ids = list.multipleSelection
        this.deleteSource.isMul = true
      }
      this.deleteSource.url = `cms/contents/${this.contentId}/del/${deal.id}`
      this.$refs.deleteDeal.beforeDelete()
    },
    importItem(list, importId) {  // 执行导入操作
      // this.importSource.url = `cms/contents/${this.contentId}/importlist/${list.id}`
      this.importSource.url = `cms/contents/${this.contentId}/importlist/${importId}`
      this.$refs.importDeal.openUpload()
    },
    exportItem(deal, list) {  // 执行导出操作
      let url = ''
      if (deal.export_type == this.EXPORT_LIST) { // 跟列表相同
        url = `cms/contents/${this.contentId}/exportlist/${list.id}`
      } else {  // 自定义配置
        url = `cms/contents/${this.contentId}/exportlist/${deal.id}`
      }
      let postData = this.makeFilterData(list.filterData, list.currentTag.condition, list.currentPage, list.currentSize, list, this.combinationNumber)
      delete postData.limit
      delete postData.page
      this.exportSource.url = url
      this.exportSource.postData = postData
      if (deal.choose_column == 1) { // 允许用户选择列，弹窗给出选项
        if (deal.export_type == this.EXPORT_LIST) { // 跟列表相同
          this.exportSource.column = list.column
        } else {  // 自定义配置
          this.exportSource.column = deal.column
        }
        this.$refs.exportDeal.openDialog()
      } else {  // 不允许用户选择，直接导出
        this.exportSource.exportCols = []
        this.$refs.exportDeal.doExport()
      }
      // let newWin = window.open('', '_blank')
      // this.apiPost(url, postData).then((res) => {
      //   if (res.code == 200) {
      //     newWin.location = HOST + res.data
      //     setTimeout(() => {
      //       newWin.close()
      //     }, 500)
      //   } else {
      //     _g.dealError(this, res)
      //   }
      // })
    },
    normalSearch() {  // 普通搜索（区别于高级搜索）
      let fieldArr = []
      _(this.commonFilterData).forEach((res) => {
        res.exist = false
        fieldArr.push(res.field.toString())
      })
      _(this.advanceFilterData).forEach((res) => {
        if (_.findIndex(fieldArr, (item) => {
          return res.field.toString() == item
        }) > -1) {
          res.exist = true
        } else {
          res.exist = false
        }
      })
      this.commonSearch()
    },
    searchItem(list) {  // 执行搜索操作
      list.loading = true
      list.filterData = this.filterData
      // list.currentTag.id = ''
      // list.currentTag.condition = {}
      list.currentPage = 1
      let postData = this.makeFilterData(list.filterData, list.currentTag.condition, list.currentPage, list.currentSize, list, this.combinationNumber)
      this.getListData(postData, list)
      this.doFillFilter(postData, this.commonFilterData, list)
      this.doFillFilter(postData, this.advanceFilterData, list)
      this.doFillCondition(postData, list)
      list.filterData = this.commonFilterData.concat(this.advanceFilterData)
    },
    filterItem(deal, list) {  // 执行筛选操作
      list.loading = true
      if (list.currentTag.id == deal.id) {
        list.currentTag.id = ''
        list.currentTag.condition = []
      } else {
        list.currentTag.id = deal.id
        list.currentTag.condition = deal.condition
      }
      // list.currentTag.id = deal.id
      // list.currentTag.condition = deal.condition
      list.currentPage = 1
      this.beforeGetListData(list)
    },
    changeStatus(deal, row, list) { // 执行修改状态操作
      this.statusSource.list = list
      if (row) {  // 修改单个状态
        this.statusSource.url = `cms/contents/${this.contentId}/deal/${deal.id}/toggle/${row.id}`
        this.statusSource.isMul = false
      } else {  // 批量修改状态
        this.statusSource.ids = list.multipleSelection
        this.statusSource.url = `cms/contents/${this.contentId}/deal/${deal.id}/toggle`
        this.statusSource.isMul = true
      }
      setTimeout(() => {
        this.$refs.statusDeal.beforeChangeStatus()
      }, 0)
    },
    downloadItem(col, row) { // 执行单个下载操作（配置在列中）
      let list = null
      list = this.listConfig
      let url = `cms/contents/deal/${list.id}/download/${row.id}/${col.field_name}`
      let newWin = window.open('', '_blank')
      this.apiGet(url).then((res) => {
        if (res.code == 200) {
          newWin.location = HOST + res.data
          setTimeout(() => {
            newWin.close()
          }, 500)
        } else {
          _g.dealError(this, res)
        }
      })
    },
    async getLog(contentId, dealId) {
      let arr = []
      let res = await this.apiGet(`cms/contents/${contentId}/excellog/${dealId}`)
      return this.promiseHandler(arr, res)
    },
    async openImportLogDialog(contentId, dealId) {
      this.importlogData = await this.getLog(contentId, dealId)
      // debugger
      this.$refs.importlog.open()
    },
    downloadTemplate(deal) {
      window.location.href = deal.excel_url
      // let newWin = window.open('', '_blank')
      // this.apiGet(deal.excel_url).then((res) => {
      //   if (res.code == 200) {
      //     newWin.location = HOST + res.data
      //      setTimeout(() => {
      //       newWin.close()
      //     }, 500)
      //   } else {
      //     _g.dealError(this, res)
      //   }
      // })
    },
    downloadRowItem(deal, row, list) { // 执行单个下载操作（配置在操作按钮区）
      let url = `cms/contents/list/0/download/${deal.id}/${row.id}`
      let newWin = window.open('', '_blank')
      this.apiGet(url).then((res) => {
        if (res.code == 200) {
          newWin.location = HOST + res.data
          setTimeout(() => {
            newWin.close()
          }, 500)
        } else {
          _g.dealError(this, res)
        }
      })
    },
    downloadMultiItem(deal, list) { // 执行批量下载操作
      let url = `cms/contents/deal/${deal.id}/download`
      let postData = {
        ids: list.multipleSelection,
        list_id: list.id
      }
      let newWin = window.open('', '_blank')
      this.apiPost(url, postData).then((res) => {
        if (res.code == 200) {
          newWin.location = HOST + res.data
          setTimeout(() => {
            newWin.close()
          }, 500)
        } else {
          _g.dealError(this, res)
        }
      })
    },
    jumpPage(col, row) {  // 执行页面跳转操作
      let query = ''
      if (col.link_option && col.link_option.length) {
        _(col.link_option[0].fields).forEach((item) => { // 根据配置生成query值
          query += `${item}=${row[`${col.link_option[0].param}`]}&`
        })
        query = query.substr(0, query.length - 1)
        let encodeQuery = base64.encode(utf8.encode(query)) // 进行base64转码
        if (col.link_option[0].reality) {
          router.push({
            name: 'renderPage',
            params: { contentId: col.link_option[0].reality.id },
            query: { is_jump: 1, dataId: row.id, query: encodeQuery }
          })
        }
      }
    },
    sendParams(col, row) {  // 传参给同页一级功能集
      let queryArr = []
      if (col.link_option && col.link_option.length) {
        _(col.link_option).forEach((res) => {
          let query = ''
          _(res.fields).forEach((item) => { // 根据配置生成query值
            query += `${item}=${row[`${res.param}`]}&`
          })
          query = query.substr(0, query.length - 1)
          let encodeQuery = base64.encode(utf8.encode(query)) // 进行base64转码
          if (res.reality) {
            queryArr.push({
              contentId: res.reality.id,
              query: { is_jump: 1, dataId: row.id, query: encodeQuery }
            })
          }
        })
      }
      this.$emit('sendParams', queryArr)
    },
    /**
     * 查看关联数据
     */
    showRelate(col, row) {
      this.relateSource.ids = row[col.field_name]
      this.relateSource.field_name = col.field_name
      this.relateSource.list_id = this.listConfig.id
      this.relateSource.title = col.show_name
      this.relateSource.url = col.deal_type === this.LINK_SHOWRELATE ? 'cms/deals/multi_data' : 'cms/deals/child_data'
      this.$refs.relateDeal.open()
    },
    openRepeatDialog(data) {
      this.repeatDetail = data
      this.$refs.repeat.open()
    },
    sendMessage(deal, row) {        // 消息推送
      let url = 'cms/contents/message'
      let postData = {
        deal_id: deal.id,
        id: row.id
      }
      this.apiPost(url, postData).then((res) => {
        if (res.code == 200) {
          _g.toastMsg(this, 'success', res.data)
        } else {
          _g.dealError(this, res)
        }
      })
    },
    /**
     * 执行函数实例化
     * @param  {Object: 执行函数对象}
     * @return {[type]}
     */
    execFunction(deal, row, list) {
      let url = `cms/contents/function/${deal.id}`
      // 列表内操作
      if (row) {
        url += `?data_id=${row.id}`
      }
      this.apiGet(url).then((res) => {
        if (res.code == 200) {
          _g.toastMsg(this, 'success', res.data)
        } else {
          _g.dealError(this, res)
        }
      })
    },
    /**
    * 导出word文档
    */
    exportWord(deal, row, list) {
      // 列表内操作
      let postData = {
        id: row.id,
        deal_id: deal.id,
        current: list.currentPage,
        pageSize: list.currentSize,
        pagination: list.pagination
      }
      this.apiPost('cms/contents/replace_word', postData).then((res) => {
        if (res.code == 200) {
          let newWin = window.open('', '_blank')
          newWin.location = HOST + res.data
          setTimeout(() => {
            newWin.close()
          }, 500)
        } else {
          _g.toastMsg(this, 'error', res.error)
        }
      })
    },
    sendEmail(deal, row, list) { // 发送邮件
      if (_g.isRealEmpty(row) && _g.isRealEmpty(list.multipleSelection)) {
        _g.toastMsg(this, 'warning', '请先选择要处理的数据')
        return
      }
      if (row) {
        this.emailSource.ids = [row.id]
      } else {
        this.emailSource.ids = list.multipleSelection
      }
      this.emailSource.dealId = deal.id
      this.emailSource.url = `cms/contents/${this.contentId}/sendemail/${deal.id}`
      this.$refs.emailDeal.openDialog()
    },
    /**
    * 一维统计图表
    */
    dimensionalChart(deal, list) {
      router.push({
        name: 'chartPage',
        params: { id: deal.id, contentId: this.contentId }
      })
    },
    getSelfDataCallback(postData) { // 自定义方法回调
      if (!postData || _g.isRealEmpty(postData.params)) {
        return
      }
      let arr = postData.params
      _(arr).forEach((item) => {
        if (_g.isRealEmpty(item.postArr) || !item.fieldName) {
          return
        }
        let temp = this
        _(item.postArr).forEach((childItem) => {
          temp = temp[`${childItem}`]
          if (_g.isRealEmpty(temp)) {
            temp = null
            return false
          }
        })
        // this.selfData[item.fieldName] = temp
        this.$set(this.selfData, item.fieldName, temp)
      })
    },
    doFillFilter(data, filterArr, list) { // 填充筛选区的内容
      if (data.filter) {  // 单行文本
        _(data.filter).forEach((res, index) => {
          _(filterArr).forEach((filter, key) => {
            if (filter.field.toString() == res.field.toString() &&
               (filter.type == this.FILTER_INPUT ||
                filter.type == this.FILTER_INPUT_THREE_PART ||
                filter.type == this.FILTER_INPUT_HALF_LONG ||
                filter.type == this.FILTER_CHECKBOX ||
                filter.type == this.FILTER_FOREIGNKEYCHECKBOX ||
                filter.type == this.FILTER_TIME_RANGE ||
                filter.type == this.FILTER_RELATEX_TEXT)) { // 除了范围和下拉
              filter.value = res.value
              return false
            }
          })
        })
      }
      if (data.select) {  // 下拉 关联文本
        _(data.select).forEach((res, index) => {
          _(filterArr).forEach((filter, key) => {
            if ((filter.type == this.FILTER_SELECT ||
                 filter.type == this.FILTER_FOREIGNKEY ||
                 filter.type == this.FILTER_COLOR_SELECT) &&
                filter.field.toString() == res.field.toString()) { // 下拉
              if (filter.type == this.FILTER_SELECT) {
                if (filter.isMultiple) {
                  filter.value = res.value
                } else {
                  filter.value = res.value[0]
                }
              } else if (filter.type == this.FILTER_FOREIGNKEY) {
                filter.value = res.value
              } else if (filter.type == this.FILTER_COLOR_SELECT) {
                filter.value = res.value
              } else if (filter.type == this.FILTER_RELATEX_TEXT) {
                filter.value = res.value
              }
              return false
            }
          })
        })
      }
      if (data.range) {  // 单行文本
        _(data.range).forEach((res, index) => {
          _(filterArr).forEach((filter, key) => {
            if (filter.field.toString() == res.field.toString()) { // 范围选择
              if (filter.type == this.FILTER_DATERANGE) {
                filter.value = []
                filter.value.push(res.from)
                filter.value.push(res.to)
              } else if (filter.type == this.FILTER_RANGE) {
                filter.from = res.from
                filter.to = res.to
              }
              return false
            }
          })
        })
      }
      if (data.date_range) {
        _(data.date_range).forEach((res) => {
          _(filterArr).forEach((filter, key) => {
            if (filter.field.toString() == res.field.toString()) {
              if (filter.type == this.FILTER_TIME_RANGE) {
                filter.value = []
                filter.value.push(res.from)
                filter.value.push(res.to)
              }
              return false
            }
          })
        })
      }
    },
    async doFillCondition(data, list) { // 填充筛选标签
      let filterId = list.id
      if (data.condition) { // 筛选标签
        _(this.listConfig.handle).forEach((handle) => {
          if (handle.type == this.OPERATION_FILTER) {
            // filterId = handle.tag_iden
            if (handle.tag_iden === data.tag_iden || (_g.isRealEmpty(data.tag_iden) && handle.tag_iden == -1)) {
              // filterId = handle.tag_iden
              this.listConfig.currentTag.id = handle.tag_iden
              this.listConfig.currentTag.condition = handle.condition
              this.curTabLeftBtnName = handle.name
              return false
            }
          }
        })
      }
      let postData = {
        maps: {
          filter: data.filter,
          condition: data.condition,
          select: data.select,
          range: data.range,
          buildFilter: data.buildFilter, // 组合筛选下拉框
          date_range: data.date_range // 时间范围控件
        }
      }
      if (this.isJump) {
        postData.query = this.listQuery
      }
      // if (!_g.isRealEmpty(filterId)) {
      //   let resData = await this.getFilterNumber(this, postData, this.contentId, filterId)
      //   if (resData) {
      //     this.getFilterCount(this.listConfig, resData)
      //   }
      // }
    },
    // async getFilterNumber(obj, postData, contentId, dealId) {
    //   let res = await obj.apiPost(`cms/contents/${contentId}/tagdata/${dealId}`, postData)
    //   let data = obj.promiseHandler(data, res)
    //   return data
    // },
    setFilterQuery(data) {  // 把筛选条件处理掉并通知render.vue设置到url上
      console.log('ListRendeer setFilterQuery = ', _g.s2j(_g.j2s(data)))
      if (data.filter) {
        _.remove(data.filter, (res) => {
          return _g.isRealEmpty(res.value)
        })
      }
      if (data.range) {
        _.remove(data.range, (res) => {
          return _g.isRealEmpty(res.value) &&
                 _g.isRealEmpty(res.from) &&
                 _g.isRealEmpty(res.to)
        })
      }
      if (data.select) {
        _.remove(data.select, (res) => {
          return _g.isRealEmpty(res.value)
        })
      }
      this.$emit('setFilterQuery', data, this.index)
    }
  }
}

export default dealMethod



// WEBPACK FOOTER //
// ./src/components/Content/instance/mixins/dealMethod.js